import { WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LiveReportsStoreService {
  _liveReports$ = new BehaviorSubject<any[]>(null);

  constructor(private reportService: WalkAndPunchApiClient) {}

  refreshReports() {
    this.loadLiveReports().subscribe((data) => {
      this.liveReports = data;
    });
  }

  loadLiveReports() {
    return this.reportService.v1ReportGetCustomReportsForUserRoleGET();
  }

  get liveReports() {
    return this._liveReports$.value;
  }

  set liveReports(data: any[]) {
    this._liveReports$.next(data);
  }

  get liveReports$() {
    return this._liveReports$;
  }
}
